<template>
  <div style="height: 100%">
	<div class="rms-container"
	v-infinite-scroll="loadMore"
	infinite-scroll-disabled="loading"
	infinite-scroll-distance="10">
		<!-- 搜索 -->
		<div class="search">
        <el-input
          placeholder="合作项目"
          v-model="formInline.queryStr"
          size="small"
        >
				<el-button slot="append" size="small" @click="query()">查询</el-button>
			</el-input>
		</div>
      <div style="height: 54px"></div>

		<!-- 列表 -->
		<div class="list-container" v-if="tableList.length>0">
			<el-card class="item" v-for="(item, index) in tableList" :key="index">
          <div class="content" @click="itemClick(item)">
					<div class="text row">
              <div class="cell-l">{{ item.zproject1 }}</div>
					</div>
				</div>
			</el-card>
		</div>

		<!-- 加载更多 -->
		<div class="scroll-more" v-if="loading">加载中...</div>
		<div class="scroll-more" v-if="tableList.length > 0 && listsClose">没有更多了</div>
      <el-empty
        description="暂无数据"
        v-if="tableList.length == 0 && listsClose"
      ></el-empty>
	</div>
	<!-- 水印 -->
	<v-Watermark v-if="watermarkContent" :content="watermarkContent"></v-Watermark>
</div>
</template>

<script>
import Watermark from "../../../components/RMS/watermark";
export default {
name: "RMSH5List",
components:{
    "v-Watermark": Watermark,
},
data () {
	return {
		uName: sessionStorage.getItem("UNAME"),

      watermarkContent: null, //水印
		//分页
		paginationConf:{
			pageNum:0,
        pageSize: 15
		},
		loading: false,
		listsClose: false,
      //form
      formInline: {
		    isMobile: 1,
        paramType: 5,
        queryStr: ""
      },
      tableList: [], //列表
      timer: null,
	};
},
created() {
    this.watermarkContent =
      sessionStorage.getItem("NICKNAME") +
      (sessionStorage.getItem("MOBILE").toString() != "null"
        ? sessionStorage.getItem("MOBILE").slice(-4)
        : "");
    if (this.$route.query.type == "1") {
      document.title = "已送货未开票";
	}else{
      document.title = "已开票未回款";
    }
    this.loadMore();
  },
  destroyed() {
    clearTimeout(this.timer);
    this.timer = null;
},
methods: {
	// 初始化
	async init(){
      let res = await this.$api.rmsHomeProjectList({
        ...this.formInline,
        dataty: document.title,
        ...this.paginationConf,
      });
		if(res.code===200 && res.result){
        this.tableList = this.tableList.concat(res.result);
        if (res.result.length < this.paginationConf.pageSize) {
				this.listsClose = true;
			}
		}else{
			this.listsClose = true;
      }
	},
	// 查询
	query(){
		this.tableList = [];
		this.paginationConf.pageNum = 0;
		this.loading = false;
		this.listsClose = false;
		this.loadMore();
	},
    itemClick(item) {
      this.$router.push({
        path: `/RMS/H5/customerList?dataty=${document.title}&zproject1=${item.zproject1}&type=${this.$route.query.type}`,
      });
    },
	// 加载列表数据/滑到底部自动加载
    async loadMore() {
		if (this.listsClose) {
			return false;
      }
		this.loading = true;
      this.timer = setTimeout(async () => {
			this.paginationConf.pageNum += 1;
			await this.init();
			this.loading = false;
		}, 200);
	},
	},
};
</script>
<style lang="less" scoped>
.rms-container {
	height: 100%;
	overflow-y: auto;
	position: relative;
	z-index: 2;
	.search {
		padding: 10px 15px;
		background-color: #fff;
		border-bottom: 1px solid #ececec;
		box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
	}
	.list-container {
		margin: 0 10px;
		.item {
			margin-top: 10px;
			font-size: 12px;
			/deep/.el-card__header {
				padding: 0;
			}
			/deep/.el-card__body {
				padding: 0;
			}
			.title {
				height: 40px;
				line-height: 40px;
				padding: 0 5px;
				font-weight: bold;
				display: flex;
				justify-content: space-between;
				.cell {
					padding: 0 2px;
					white-space: nowrap;
					&.cell-l {
            width: calc(~"100% - 140px");
						overflow: hidden;
						text-overflow: ellipsis;
					}
					&.cell-c {
						width: 80px;
						text-align: right;
					}
					&.cell-r {
						width: 46px;
						text-align: right;
            color: #d9001b;
					}
				}
			}
			.content {
				padding: 10px;
				.row {
					display: flex;
				}
				.text {
					line-height: 16px;
					padding: 3px 0;
					.small {
						color: #999;
					}
				}
				.cell-l {
					min-width: 90px;
				}
			}
			.btn {
        border-top: 1px solid #ebeef5;
				padding: 5px 10px;
				text-align: right;
			}
		}
	}
}
.scroll-more {
	padding: 15px 0;
	text-align: center;
	font-size: 14px;
	color: #5e6d82;
}
</style>
